import axios from 'axios'

export const HTTP = axios.create({
  // eslint-disable-next-line
  baseURL: process.env.VUE_APP_APIURL
})

export default { HTTP }
